// extracted by mini-css-extract-plugin
module.exports = {"root":"EditProjectListingNamePanel_root__3mSgy","form":"EditProjectListingNamePanel_form__30RGF","title":"EditProjectListingNamePanel_title__3bazE"};